import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { CustomServiceService } from '../../service/custom-service.service';
import {  EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-employee-corner-details',
  templateUrl: './employee-corner-details.component.html',
  styleUrls: ['./employee-corner-details.component.css']
}) 
export class EmployeeCornerDetailsComponent implements OnInit {

  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, private encDec:EncryptDecryptService,private route: Router, public translate: TranslateService) { }
  backend_url: any = environment.serviceURL;
  btncontent:any = `Search`;
  limit:number=20;
  currentPage:number = 1; 
  totalRecords:number=0;
  language:any = sessionStorage.getItem('locale');//dynamic

  param_id:any="";
  title_type:any="";
  title_type_:any="";
  type:any="";
  ngOnInit(): void {
    this.btncontent=(this.language=='English') ? 'Search' :'खोजें';

    document.title='Employee Corner Details';
    this.param_id = this.encDec.decText(this.routerparam.snapshot.paramMap.get('param_id'));
    if(this.routerparam.snapshot.paramMap.get('param_id')){
      this.title_type = this.param_id.split('-')[1];
      this.param_id =this.param_id.split('-')[0];

      if(this.title_type=='Document'){
        if(this.language=='English'){
          this.title_type_ = 'Document';
        } else {
          this.title_type_ = 'दस्तावेज़';
        }
        this.type = 1;
        this.getEmpeeloyCornerDoc('',this.currentPage,this.param_id,this.type);
      }
      if(this.title_type=='Internal Application'){
        if(this.language=='English'){
          this.title_type_ = 'Internal Application';
        } else {
          this.title_type_ = 'आंतरिक अनुप्रयोग';
        }
        this.type = 2;
        this.getEmpeeloyCornerDoc('',this.currentPage,this.param_id,this.type);
      } 
    }
  }




  searchForm = new FormGroup({
    title: new FormControl(''),
  })

  get title() {
    return this.searchForm.get('title');
  }

  RefreshBtn:boolean=false;
  RefreshPage(){
    this.limit=20;
    this.currentPage = 1;
    this.totalRecords = 0;
    this.getEmpeeloyCornerDoc('',this.currentPage,this.param_id,this.type);
    this.RefreshBtn = false;
    this.searchForm.reset();
  }

  searchTender(){
    let param_arr = []; 
    let title;
    title="";
    if(this.searchForm.value.title!==""){
      if(this.searchForm.value.title!==null){
        param_arr.push(this.searchForm.value.title);
        title = this.searchForm.value.title;
      }
    }
    if(param_arr.length <= 0){
      if(this.language=='English'){
        alert('Please select at least one parameter');
      }else{
        alert('कृपया कम से कम एक पैरामीटर चुनें');  
      }
      return;
    }
    this.RefreshBtn=true;
    this.limit=20;
    this.currentPage = 1;
    this.totalRecords = 0;
    this.getEmpeeloyCornerDoc(title,this.currentPage,this.param_id,this.type);
  }







  pageChanged(page: any) {
    this.currentPage=page
    this.getEmpeeloyCornerDoc('',this.currentPage,this.param_id,this.type);
  }

  ifdisabled:boolean=false;
  conrner_apirespons: any;
  Details: any = {};
  fileDetails: any = []; 
  EmployeeDetails: any = [];
  bdtitle:any='Employee Corner Detials';
  listform:number=1;
  getEmpeeloyCornerDoc(doc_title:any,currentPage:any,rowid:any,type:any) { 
    let params = {"intParentId": rowid,"type":type,"limit":this.limit,'doc_title':doc_title};
    this.httpservice.EmpeeloyCornerDoclist(params,currentPage).subscribe((response: any) => {
      switch (response.type) { 
        case HttpEventType.Sent: 
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //  let total = response.total?response.total:0;
          //  console.log(Math.round(response.loaded / total * 100));
          break;
        case HttpEventType.Response:
        this.conrner_apirespons = response.body;
        let respData = this.conrner_apirespons.RESPONSE_DATA;
        let respToken = this.conrner_apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          if(response_.original.status){
            this.fileDetails = response_.original.doc_list;
          
            this.EmployeeDetails=response_.original.Employee_dtl;
            this.totalRecords = response_.original.totalRecords;
            if(this.language=='English'){
              this.bdtitle = this.EmployeeDetails.DOC_TITLE;
            } else {
              this.bdtitle = this.EmployeeDetails.DOC_TITLE_HINDI;
            }
            this.listform = response_.original.doc_list_paginate.from;
          } else {
            console.error(response_.original);
          }
        } 
        this.ifdisabled = false;
        this.btncontent = `Search`;
      }
    });
  }

 

  jsonConvert(data: any, type: any) {
    if(data=="" || data==null){
      return "";
    }
    if(data.jsonOptTxtDetails=="" || data.jsonOptTxtDetails == null){
      return "";
    }
    let d = JSON.parse(data.jsonOptTxtDetails);
    if (type == 'FROM_YEAR') {
      return d.FROM_YEAR;
    } else if (type == 'TO_YEAR') {
      return d.TO_YEAR;
    } else {
      return '';
    }

  }

htmlTag(data:any){
  return this.encDec.decodeHtml(data);
}

encode(data:any){
  return btoa(data);
}

htmldecode(str: any){
  return this.encDec.decodeHtml(str);
}


ViewDocument(url:any,f:any):any{
  if(f==''){
    return false;
  }
  var strWindowFeatures = "location=yes,height=870,width=620,scrollbars=yes,status=yes";
  window.open( `${url}${f}`, "_blank",strWindowFeatures);
}

getlastTwo(d:any){
  if(d==""){
    return "";
  }
  let exd = d.split(" ");
  if(exd.length <= 0){
    return "";
  }
  let exdate = exd[0].split("/");
  if(exdate.length <  3){
    return "";
  }
  return exdate[2].replace(",", " ");
}



checkFileExists(obj:any):boolean{
  if(obj.selectDocument==""){
    return false;
  }
  if(obj.selectDocument_details==undefined){
    return false;
   }
  if(obj.selectDocument_details.fileSize==undefined){
    return false;
   }
 if(obj.selectDocument_details.fileSize==""){
  return false;
 }
return true;
}

Files_:any = (data:any)=>{
  if(data==""){
    return [];
  }
  if(data.length <= 0){
    return [];
  }
  var list = [];
  for (let i = 0; i < data.length; i++) {
      if(data[i].selectFile!==''){
        if(data[i].selectFile_details.fileSize!==''){
          list.push(data[i]);
        }
      }  
  } 
  return list;
}



checkFileType(data:any):any{
  let ext:any,fileType:any;
  ext= ['webp','jpeg', 'jpe', 'png', 'gif', 'jpg', 'pdf', 'PNG','xlsx','xls','csv','docx','doc'];
  if(data==""){
    return false; 
  }
  if(data.DOC_Details==""){
    return false; 
  }
  if(data.DOC_Details==undefined){
    return false; 
  }
  if(data.DOC_Details.fileType==undefined){
    return false; 
  }
  if(data.DOC_Details.fileType==''){
    return false; 
  }
  fileType=data.DOC_Details.fileType.toLowerCase();
  if(fileType=='xlsx' || fileType=='xls' || fileType=='csv'){
    return {'fileType':fileType,'file': ` || <i class="fa fa-file-excel-o" aria-hidden="true"></i> ${fileType} ||`}; 
  } else if(fileType=='docx' || fileType=='doc'){
    return {'fileType':fileType,'file':` || <i class="fa fa-file-word-o" aria-hidden="true"></i> ${fileType} ||`}; 
  } else if(fileType=='pdf'){
    return {'fileType':fileType,'file':` || <i class="fa fa-file-pdf-o" aria-hidden="true"></i> ${fileType} ||`}; 
  } else {
    return {'fileType':fileType,'file':` || <i class="fa fa-file-text" aria-hidden="true"></i> ${fileType} ||`}; 
  }

}



}

